export const ROLES = {
  ADMIN: 1,
  HR: 2,
  INTERVIEWER: 3,
  CANDIDATE: 4,
  HR_AND_INTERVIEWER: 5
};

export const STATUS = {
  PENDING: 1,
  ACCEPT: 2,
  REJECT: 3,
  ACCEPT_BY_OTHER: 4,
  AUTO_REJECT: 5
};

export const RENDER = {
  Yes: true,
  No: false
};

export const TINY_MCE_PLUGINS = [
  'advlist',
  'autolink',
  'lists',
  'link',
  'image',
  'charmap',
  'preview',
  'anchor',
  'searchreplace',
  'visualblocks',
  'code',
  'fullscreen',
  'insertdatetime',
  'media',
  'table',
  'code',
  'help',
  'wordcount'
];

export const INTERVIEW_INVITATION_STATUS = {
  1: 'Pending',
  2: 'Accepted',
  3: 'Rejected',
  4: 'Accepted by Others',
  5: 'Auto Rejected'
};

export const Interview_Invitations_Status = {
  Pending: 1,
  Accepted: 2,
  Rejected: 3,
  'Accepted by Others': 4,
  'Auto Rejected': 5
};

export const ROUTE_PREFIX_FROM_ROLE = {
  1: 'ADMIN',
  2: 'HR',
  3: 'INTERVIEWER'
};

export const INTERVIEW_STATUS = {
  COMPLETE: 2,
  CANCEL: 3
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:token',
  RESET_PASSWORD_WITHOUT_TOKEN: '/reset-password',
  // USER_PROFILE: '/profile',
  USER_PASSWORD: '/user/password',
  ADMIN: {
    DASHBOARD: '/admin/dashboard',
    USER_PROFILE: '/admin/profile',
    INTERVIEWERS: '/admin/interviewers',
    INTERVIEWER_ADD: '/admin/interviewers/add',
    INTERVIEWER_EDIT: '/admin/interviewers/:ID',
    HRS: '/admin/HRs',
    HR_ADD: '/admin/hrs/add',
    HR_EDIT: '/admin/hrs/:ID',
    CANDIDATES: '/admin/candidates',
    DESIGNATION: '/admin/jobdesignations',
    DESIGNATION_ADD: '/admin/designation/add',
    DESIGNATION_EDIT: '/admin/designation/:ID',
    TECHNOLOGY: '/admin/technologies',
    TECHNOLOGY_ADD: '/admin/technology/add',
    TECHNOLOGY_EDIT: '/admin/technology/:ID',
    DESCRIPTIONS: '/admin/jobdescriptions',
    COMMON_PARAMETERS: '/admin/feedback-parameters'
  },
  HR: {
    DASHBOARD: '/hr/dashboard',
    USER_PROFILE: '/hr/profile',
    CANDIDATES: '/hr/candidates',
    CANDIDATES_ADD: '/hr/candidates/add',
    CANDIDATES_EDIT: '/hr/candidates/:ID',
    INTERVIEWS: '/hr/interviews',
    INTERVIEW_ROUNDS: '/hr/interviews/:ID',
    INTERVIEW_ROUND: '/hr/interviews',
    INTERVIEWS_EDIT: '/hr/interviews/:ID',
    INTERVIEWS_ADD: '/hr/interviews/add',
    INTERVIEWS_ROUND_EDIT_ID: '/hr/interview-rounds/edit/:ID',
    INTERVIEWS_ROUND_EDIT: '/hr/interview-rounds/edit',
    INTERVIEWS_ROUND_ADD: '/hr/interview-rounds/add',
    INTERVIEWS_ROUND_ADD_ID: '/hr/interview-rounds/add/:addingID',
    INTERVIEW_SCHEDULE: '/hr/interviewers',
    DESIGNATION: '/hr/designation',
    DESIGNATION_ADD: '/hr/designation/add',
    DESIGNATION_EDIT: '/hr/designation/:ID',
    TECHNOLOGY: '/hr/technology',
    TECHNOLOGY_ADD: '/hr/technology/add',
    TECHNOLOGY_EDIT: '/hr/technology/:ID'
  },
  INTERVIEWER: {
    DASHBOARD: '/interviewer/dashboard',
    USER_PROFILE: '/interviewer/profile',
    SCHEDULED_INTERVIEW: '/interviewer/scheduled_interview',
    AVAILABILITY: '/interviewer/availability',
    INTERVIEW_INVITATION: '/interviewer/invitations',
    INTERVIEW_SCHEDULED: '/interviewer/interviews',
    INTERVIEW_HISTORY: '/interviewer/history'
  },
  NOT_ALLOWED: '/not-allowed',
  NOT_FOUND: '*'
};

export const API_ERROR_MESSAGES = {
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden Error',
  404: 'Not found',
  500: 'Internal server error',
  503: 'Service unavilable',
  default: 'Something went wrong !'
};

export const RESPONSE_STATUS_CODES = {
  UPDATE: 202,
  SUCCESS: 204,
  OK: 200,
  CREATED: 201,
  SESSION_EXPIRED: 419,
  TOKEN_EXPIRED: 440,
  UNAUTHORIZED: 401,
  FORBIDDEN_ERROR: 403
};

export const STORAGE_KEY = '!m$@uth';
export const KEEP_SIGN_IN_KEY = 'keepSignIn';

export const SECRET_KEY = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const SUPPORTED_FORMATS = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];

export const TECHNICAL_FEEDBACK_PARAMETERS = ['Front-end', 'Back-end', 'Database'];

export const USER_TYPE = {
  CANDIDATES: 'CANDIDATES',
  HRS: 'HRS',
  INTERVIEWERS: 'INTERVIEWERS'
};

export const INTERVIEW_TYPE = [
  { name: 'Technical Interview - 1', code: 1 },
  { name: 'Technical Interview - 2', code: 4 },
  { name: 'Management Round', code: 5 },
  { name: 'Practical', code: 2 },
  { name: 'HR Round', code: 3 }
];

export const INTERVIEW_MODE = [
  { name: 'Tatvasoft Office', code: 1 },
  { name: 'Rajkot Office', code: 2 },
  { name: 'Online', code: 3 }
];

export const INTERVIEW_MODE_LIST = {
  CALENDER_VIEW: 'calender',
  LIST: 'list'
};

export const InterviewMode = {
  'Tatvasoft Office': 1,
  'Rajkot Office': 2,
  Online: 3
};

export const InterviewType = {
  'Technical Interview - 1': 1,
  Practical: 2,
  'HR Round': 3,
  'Technical Interview - 2': 4,
  'Management Round': 5
};

export const CANDIDATE_SOURCE_TYPE = [
  { name: 'Manual', code: 1 },
  { name: 'Naukri', code: 2 },
  { name: 'LinkedIn', code: 3 },
  { name: 'Reference', code: 4 }
];
export const INTERVIEW_STATUS_HISTORY = [
  { name: 'Completed', code: 3 },
  { name: 'Completed', code: 6 },
  { name: 'Completed', code: 9 },
  { name: 'Cancelled', code: 10 },
  { name: 'Completed', code: 16 },
  { name: 'Completed', code: 20 }
];

export const INTERVIEW_STATUS_LIST = [
  { name: 'Technical Interview - 1 Pending', code: 1 },
  { name: 'Technical Interview - 1 Schedule', code: 2 },
  { name: 'Technical Interview - 1 Reschedule', code: 11 },
  { name: 'Technical Interview - 1 Complete', code: 3 },
  { name: 'Technical Interview - 2 Pending', code: 13 },
  { name: 'Technical Interview - 2 Schedule', code: 14 },
  { name: 'Technical Interview - 2 Reschedule', code: 15 },
  { name: 'Technical Interview - 2 Complete', code: 16 },
  { name: 'Practical Pending', code: 4 },
  { name: 'Practical Schedule', code: 5 },
  { name: 'Practical Reschedule', code: 12 },
  { name: 'Practical Complete', code: 6 },
  { name: 'Management Pending', code: 17 },
  { name: 'Management Schedule', code: 18 },
  { name: 'Management Reschedule', code: 19 },
  { name: 'Management Complete', code: 20 },
  { name: 'HR Pending', code: 7 },
  { name: 'HR Schedule', code: 8 },
  { name: 'HR Reschedule', code: 21 },
  { name: 'HR Complete', code: 9 },
  { name: 'Cancelled', code: 10 }
];

export const INTERVIEW_COLORS = {
  PENDING: '#D99054',
  SCHEDULE: '#DAA521',
  RESCHEDULE: '#208FC7',
  COMPLETE: '#7EB155',
  CANCEL: '#CB5555'
};

export const STATUS_INTERVIEW = {
  TECHNICAL_INTERVIEW_1_PENDING: 1,
  TECHNICAL_INTERVIEW_1_SCHEDULE: 2,
  TECHNICAL_INTERVIEW_1_COMPLETE: 3,
  PRACTICAL_PENDING: 4,
  PRACTICAL_SCHEDULE: 5,
  PRACTICAL_COMPLETE: 6,
  HR_PENDING: 7,
  HR_SCHEDULE: 8,
  HR_RESCHEDULE: 21,
  HR_COMPLETE: 9,
  CANCELLED: 10,
  TECHNICAL_INTERVIEW_1_RESCHEDULE: 11,
  PRACTICAL_RESCHEDULE: 12,
  TECHNICAL_INTERVIEW_2_PENDING: 13,
  TECHNICAL_INTERVIEW_2_SCHEDULE: 14,
  TECHNICAL_INTERVIEW_2_RESCHEDULE: 15,
  TECHNICAL_INTERVIEW_2_COMPLETE: 16,
  MANAGEMENT_PENDING: 17,
  MANAGEMENT_SCHEDULE: 18,
  MANAGEMENT_RESCHEDULE: 19,
  MANAGEMENT_COMPLETE: 20
};

// Using separate constant value then interview round due to different status values.
export const PARENT_INTERVIEW_STATUS_LIST = [
  { name: 'Pending', code: 1 },
  { name: 'Completed', code: 2 },
  { name: 'Cancelled', code: 3 }
];

export const PARENT_STATUS_INTERVIEW = {
  PENDING: 1,
  COMPLETED: 2,
  CANCELLED: 3
};

export const DURATION = [
  { name: '30 Min', code: 30 },
  { name: '1 Hour', code: 60 },
  { name: '1.5 Hour', code: 90 },
  { name: '2 Hour', code: 120 },
  { name: '2.5 Hour', code: 150 }
];

export const INTERVIEW_CATEGORY = [
  { name: 'Technical', code: 1 },
  { name: 'Non Technical', code: 0 }
];

export const Interview_Category = {
  Technical: 1,
  'Non Technical': 0
};

export const EXPORT_TABLE = {
  EXCEL_TYPE: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  FORMAT: '.xlsx'
};

export const BUTTON_TYPES = {
  LOGIN: 'Login',
  SUBMIT: 'Submit',
  GO_BACK: 'Go Back',
  GO_BACK_HOME: ' Back to Home ',
  SEND: 'Send',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  UPLOAD_RESUME: 'Upload Resume',
  UPDATE_RESUME: 'Update Resume',
  SAVE_RESCHEDULE: 'Save & Reschedule',
  UPDATE_PASSWORD: 'Update Password',
  SAVE_EXIT: 'Save & Exit',
  ADD_NEW_SLOT: 'Add New Slot'
};

export const LABEL_TYPES = {
  EMAIL: 'Email Address',
  USERNAME: 'Username',
  PASSWORD: 'Password',
  NEW_PASSWORD: 'New Password',
  CONFIRM_PASSWORD: 'Confirm Password',
  OLD_PASSWORD: 'Old Password',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  MOBILE: 'Mobile Number',
  SECONDARY_MOBILE: 'Second Mobile Number',
  GENDER: 'Gender',
  MALE: 'Male',
  FEMALE: 'Female',
  YEAR_EXPERIENCE: 'Exp. in Years',
  MONTH_EXPERIENCE: 'Exp. in Months',
  SCHEDULE_INTERVIEW: 'Want to schedule interview?',
  START_DATE: 'Interview Start Time',
  END_DATE: 'Interview End Time',
  INTERVIEW_TYPE: 'Interview Type',
  INTERVIEW_ROUND_MODE: 'Interview Round Mode',
  DESIGNATION: 'Designation',
  JOB_DESCRIPTION_NAME: 'Name',
  JOB_DESCRIPTION_SUBJECT: 'Subject',
  TECHNOLOGY: 'Technology',
  TECHNICAL_SKILLS: 'Technical skills',
  PARAMETER: 'Parameter',
  INTERVIEWER_LIMIT: 'Number of Interviewers',
  INTERVIEWERS: 'Select Interviewers',
  DESCRIPTION: 'Description',
  UPLOAD_RESUME: 'Upload Resume',
  UPDATE_RESUME: 'Update Resume',
  ADDRESS: 'Address',
  SOFT_SKILLS: 'Soft Skills',
  TECHNOLOGIES: 'Technologies',
  FROM_TIME: 'From Time',
  TO_TIME: 'To Time',
  CANDIDATE: 'Select Candidate',
  TECHSTACK: 'TechStack',
  PACKAGE: 'Average Annual Salary',
  CANDIDATE_EXPECTATION: 'Candidate Salary Expectation',
  NOTIFICATION: 'Notification',
  COLOR_PICKER: 'Pick Color',
  CANCEL_REASON: 'Cancel Reason',
  CURRENT_COMPANY: 'Current Company',
  CURRENT_CTC: 'Current CTC',
  DATE_OF_BIRTH: 'Data of Birth',
  CANDIDATE_CURRENT_LOCATION: 'Candidate Current Location',
  CANDIDATE_SOURCE: 'Candidate Source',
  INTERVIEW_CATEGORY: 'Interview Category',
  CANDIDATE_SOURCE_REFERENCE: 'Reference Name'
};

export const MSG_TYPES = {
  NO_RESULT: 'No results found'
};

export const INITIAL_PAGE_NUMBER = 1;

export const INITIAL_SIZE = 100;

export const APLHABET_PATTERN_REGEX = /^[a-z|A-Z|\s]+$/;

export const EMAIL_PATTERN_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const NOTIFICATION_PERMISSION_MSG = 'Please allow notification permission';

export const DEBOUNCE_TIMEOUT = 500;

export const PERMISSIONS = {
  GRANTED: 'granted',
  DENIED: 'denied',
  DEFAULT: 'default'
};

export const FCM_TOKEN = 'FCM_TOKEN';

export const NOT_ALLOWED_SYMBOLS = ['e', 'E', '+', '-', '.'];

export const OVERALL_FEEDBACK = [
  { name: 'Pass', code: '1' },
  { name: 'Fail', code: '2' }
];

export const OVERALL_FEEDBACK_STATUS = {
  1: 'Pass',
  2: 'Fail'
};
// Function to compare values
export function compareValues(obj, value) {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (obj[key] === value) {
        return key;
      }
    }
  }
  return null; // If the value is not found in the object
}

export const HR_OVERALL_FEEDBACK = [
  { name: 'Selected', code: '1' },
  { name: 'Rejected', code: '2' },
  { name: 'Offered', code: '3' },
  { name: 'In Discussion', code: '4' },
  { name: 'Offer Rejected', code: '5' },
  { name: 'Offer Accepted', code: '6' }
];

export const HR_OVERALL_FEEDBACK_STATUS = {
  Selected: '1',
  Rejected: '2',
  Offered: '3',
  'In Discussion': '4',
  'Offer Rejected': '5',
  'Offer Accepted': '6'
};

export const OVERALL_GRADE = [
  { name: 'A+', code: '1' },
  { name: 'A', code: '2' },
  { name: 'A-', code: '3' },
  { name: 'B+', code: '4' },
  { name: 'B', code: '5' },
  { name: 'B-', code: '6' },
  { name: 'C', code: '7' },
  { name: 'N/A', code: '8' }
];

export const OVERALL_GRADE_STATUS = {
  1: 'A+',
  2: 'A',
  3: 'A-',
  4: 'B+',
  5: 'B',
  6: 'B-',
  7: 'C',
  8: 'N/A'
};

export const PRACTICAL_RESULT = [
  { name: 'Selected', code: '1' },
  { name: 'Rejected', code: '2' }
];

export const PRACTICAL_RESULT_STATUS = {
  1: 'Selected',
  2: 'Rejected'
};

export const CODE_QUALITY = [
  { name: 'Poor', code: '1' },
  { name: 'Good', code: '2' },
  { name: 'Great', code: '3' }
];

export const CODE_QUALITY_STATUS = {
  1: 'Poor',
  2: 'Good',
  3: 'Great'
};

export const ACTION_TYPE = {
  VIEW: 'view',
  EDIT: 'edit',
  DELETE: 'delete',
  COMPLETE: 'complete',
  ACCEPT: 'accept',
  REJECT: 'reject',
  FEEDBACK: 'feedback',
  NOTES: 'notes',
  SEND_JD: 'sendjd',
  CANCEL: 'cancel'
};

export const TABLE_NAME = {
  INTERVIEWERS: 'Interviewers_List',
  HR: 'HR_List',
  DESIGNATION: 'Job_Designation',
  JOB_DESCRIPTION: 'Job_Description',
  TECHNOLOGY: 'Technologies',
  CANDIDATE: 'Candidates_List',
  SCHEDULED_INTERVIEWS: 'Scheduled_Interviews',
  INTERVIEW_ROUNDS: 'Interview_Rounds',
  INTERVIEW: 'Interviews_List',
  INTERVIEW_HISTORY: 'Interview_History',
  INTERVIEW_INVITATIONS: 'Interview_Invitations',
  COMMON_PRAMETERS: 'Common_Parameters'
};

export const USER_TYPE_TEXT = {
  CANDIDATES: 'Total Candidates',
  HRS: 'Total HRs',
  INTERVIEWERS: 'Total Interviewers',
  PLANED_INTERVIEWS: "Today's Interview"
};

export const MOMENT_FORMATS = {
  DATE_ONLY: 'YYYY-MM-DD',
  DD_MM_YYYY: 'DD/MM/YYYY'
};

export const TEXTAREA_LIMIT = {
  MIN: process.env.REACT_APP_TEXTAREA_MIN_LIMIT || 30,
  MAX: process.env.REACT_APP_TEXTAREA_MAX_LIMIT || 300
};

export const FEEDBACK_TEXTAREA_LIMIT = {
  MIN: process.env.REACT_APP_TEXTAREA_MIN_LIMIT || 30,
  MAX: 1000
};

export const APP_VERSION = '23.06.14';

export const Calendar_Messages = {
  today: 'Today',
  previous: 'Previous',
  next: 'Next',
  month: 'Month',
  week: 'Week',
  day: 'Day'
};

export const eventStyleGetter = (event) => {
  const style = {
    backgroundColor: event.color, // Background color
    borderRadius: '1px', // Border radius
    fontSize: 11,
    fontWeight: 300,
    color: 'white', // Text color
    maxHeight: '100%',
    border: '1px solid white' // Border color
  };

  return {
    style
  };
};

export const TooltipContent = ({ event }) => {
  return (
    <>
      <div>
        <strong>Job Title :</strong> {event.jobTitle || '--'}
      </div>
      <div>
        <strong>Interviewer :</strong> {event.interviewer || '--'}
      </div>
      <div>
        <strong>Interview Level :</strong> {event.interviewLevel || '--'}
      </div>
      <div>
        <strong>Interview Mode :</strong> {event.interviewMode || '--'}
      </div>
      <div>
        <strong>Scheduled By :</strong> {event.scheduleBy || '--'}
      </div>
    </>
  );
};
